export default [
  {
    path: '/activity/marketing/match-held-free',
    name: 'activity_marketing_match_held_free',
    component: () => import('../activity/onlineMatches/marketing/HeldFree.vue'),
    meta: {
      title: '体智云官方赛事免费举办',
      ignoreLogin: true,
    },
  },
]
